interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  iconBg: string;
  iconColor: string;
  subtitle?: string;
  trend?: 'up' | 'down' | 'neutral';
}

export default function StatCard({ title, value, icon, iconBg, iconColor, subtitle }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl p-5 border border-gray-100 hover:border-sky-200 transition-all duration-200">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-500 font-medium">{title}</p>
          <p className="text-3xl font-bold text-gray-800 mt-1">{value}</p>
          {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
        </div>
        <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBg} flex-shrink-0`}>
          <i className={`${icon} text-2xl ${iconColor}`}></i>
        </div>
      </div>
    </div>
  );
}
